import React, { useState, useRef, useEffect } from 'react'
import Slider from 'react-slick'
import Image from '../../atoms/Image'
import Richtext from '../../atoms/Richtext'
import Link from '../../atoms/Link'
import SbEditable from 'storyblok-react'

const ImageSliderBlockSlider = ({ block }) => {
  const refChild = useRef([])
  const [widthState, setWidthState] = useState(0)
  useEffect(() => {
    setTimeout(() => {
      setWidthState(refChild.current.offsetWidth)
    }, 500)
  })

  function NextArrow(props) {
    const { className, onClick, widthState } = props
    return (
      <span
        className={className}
        style={
          block.mirrored
            ? { left: 'calc(50% - 2rem)' }
            : { left: 'calc(50% + ' + widthState + 'px - 1.5rem)' }
        }
        onClick={onClick}
      >
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick, widthState } = props
    return (
      <span
        className={className}
        style={
          block.mirrored
            ? {
                left: 'inherit',
                right: 'calc(50% + ' + widthState + 'px - 1.5rem)',
              }
            : {
                left: 'calc(50% + 0.5rem)',
              }
        }
        onClick={onClick}
      >
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    mobileFirst: true,
    infinite: false,
    prevArrow: <PrevArrow className="slick-prev" widthState={widthState} />,
    nextArrow: <NextArrow className="slick-next" widthState={widthState} />,
    appendDots: (dots) => (
      <ul
        style={
          block.mirrored
            ? {
                maxWidth: '50%',
                width: widthState + 'px',
                right: '50%',
              }
            : {
                maxWidth: '50%',
                width: widthState + 'px',
                left: '50%',
              }
        }
      >
        {dots}
      </ul>
    ),
    customPaging: (i) => <button>{i + 1}</button>,
  }
  return (
    <SbEditable content={block}>
      <Slider
        {...settings}
        className={`image-slider-block ${
          block.mirrored && 'image-slider-block-mirrored'
        }`}
      >
        {block.slides?.length > 0 &&
          block.slides.map((item, index) => (
            <article className="image-slider-block-item" key={index}>
              <div
                className="image-slider-block-item-image-container"
                data-rellax-center={true}
                data-rellax-speed={2}
              >
                <div className="image-slider-block-item-image">
                  <Image
                    className="img-fluid"
                    image={item.image}
                    alt={item.alt}
                    imageWidth="1920"
                    imageHeight="1440"
                  />
                </div>
              </div>

              <div
                data-rellax-center={true}
                data-rellax-speed={0}
                className="image-slider-block-item-text-bg"
              >
                <div className="image-slider-block-item-text-bg-wrapper"></div>
              </div>
              <div
                data-rellax-center={true}
                data-rellax-speed={0}
                className="image-slider-block-item-text-overlay"
              >
                <div className="image-slider-block-item-text-overlay-container">
                  <div className="image-slider-block-item-text-overlay-wrapper">
                    <div className="image-slider-block-item-text-overlay-row">
                      <div
                        ref={refChild}
                        className="image-slider-block-item-text-overlay-cell"
                      >
                        <div className="image-slider-block-item-text-overlay-inner">
                          {item.title?.length > 0 && <h2>{item.title}</h2>}
                          <Richtext text={item.subtitle} />

                          {item.link?.cached_url?.length > 0 && (
                            <Link className="btn btn-primary" link={item.link}>
                              {item.link_text}
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
      </Slider>
    </SbEditable>
  )
}

export default ImageSliderBlockSlider
